module.exports = __webpack_public_path__ + "static/media/logo-sm.034140e7.svg";